import { defineNotificationCategory, integrationPills, requireFields } from './types';

export const workIntegrationScheduleDisabledDescriptor = defineNotificationCategory(
  'work_integration_schedule_disabled',
  {
    isAvailable: requireFields('sourceSystemType', 'integrationName', 'reasonCode'),
    actionUrl: (_data, organizationId) => `/org-id/${organizationId}/settings/work-integrations`,
    serverCopy: {
      titleKey: 'workIntegrationScheduleDisabled.title',
      bodyKey: (data) => `workIntegrationScheduleDisabled.${data.reasonCode}`,
      values: (data) => ({ system: data.sourceSystemType, name: data.integrationName }),
    },
    pills: integrationPills,
  },
);

export const workIntegrationSyncErrorDescriptor = defineNotificationCategory(
  'work_integration_sync_error',
  {
    isAvailable: requireFields('sourceSystemType', 'integrationName'),
    actionUrl: (_data, organizationId) => `/org-id/${organizationId}/settings/work-integrations`,
    serverCopy: {
      titleKey: 'workIntegrationSyncError.title',
      bodyKey: 'workIntegrationSyncError.body',
      values: (data, tn) => ({
        system: data.sourceSystemType,
        name: data.integrationName,
        lastSync: data.lastSuccessfulSyncAt ?? tn('workIntegrationSyncError.neverSynced'),
      }),
    },
    pills: integrationPills,
  },
);

export const workIntegrationSetupCompleteDescriptor = defineNotificationCategory(
  'work_integration_setup_complete',
  {
    isAvailable: requireFields('integrationName'),
    actionUrl: (_data, organizationId) => `/org-id/${organizationId}/settings/work-integrations`,
    serverCopy: {
      titleKey: 'workIntegrationSetupComplete.title',
      bodyKey: 'workIntegrationSetupComplete.body',
      values: (data) => ({ name: data.integrationName }),
    },
    pills: integrationPills,
  },
);

export const workIntegrationDisconnectedDescriptor = defineNotificationCategory(
  'work_integration_disconnected',
  {
    isAvailable: requireFields('integrationName'),
    actionUrl: (_data, organizationId) => `/org-id/${organizationId}/settings/work-integrations`,
    serverCopy: {
      titleKey: 'workIntegrationDisconnected.title',
      bodyKey: 'workIntegrationDisconnected.body',
      values: (data, tn) => ({
        name: data.integrationName,
        portfolio: data.portfolioName ?? tn('workIntegrationDisconnected.fallbackPortfolioName'),
      }),
    },
    pills: integrationPills,
  },
);

export const workIntegrationPublishCompleteDescriptor = defineNotificationCategory(
  'work_integration_publish_complete',
  {
    isAvailable: requireFields('systemName', 'portfolioName'),
    actionUrl: (_data, organizationId) => `/org-id/${organizationId}/settings/work-integrations`,
    serverCopy: {
      titleKey: 'workIntegrationPublishComplete.title',
      bodyKey: 'workIntegrationPublishComplete.body',
      values: (data) => ({ system: data.systemName, portfolio: data.portfolioName }),
    },
  },
);

export const workIntegrationExcludedTeamsDescriptor = defineNotificationCategory(
  'work_integration_excluded_teams',
  {
    isAvailable: (data) => Boolean(data.integrationName) && data.excludedTeams.length > 0,
    actionUrl: (_data, organizationId) => `/org-id/${organizationId}/settings/work-integrations`,
    serverCopy: {
      titleKey: 'workIntegrationExcludedTeams.title',
      bodyKey: 'workIntegrationExcludedTeams.body',
      values: (data) => {
        const teams = data.excludedTeams.map((team) => team.teamName).join(', ');
        const loops = [...new Set(data.excludedTeams.map((team) => team.loopName))].join(', ');
        return { count: data.excludedTeams.length, name: data.integrationName, teams, loops };
      },
    },
  },
);
